<div class="flex flex-col flex-auto overflow-y-auto p-8 labels-page">
    <!-- Sidebar toggle button -->
    <button *ngIf="!defaultView" 
        mat-icon-button 
        class="lg:hidden md:-ml-2"
        (click)="_fileManagerComponent.fileManagerDrawer.toggle()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-long-left'"></mat-icon>
    </button>
    <div class="flex items-center">
       
        <!-- Title -->
        <div>
            <div class="text-3xl font-extrabold tracking-tight">Manage Labels</div>
            <div class="text-secondary">Create, update, order and delete labels</div>
        </div>
    </div>

    <!--
    <fuse-alert 
        [type]="'info'"
        [appearance]="'outline'"
        class="w-200 mt-3">
        <mat-icon class="icon-size-5"
            fuseAlertIcon
            [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
        Deleting a label will remove it from tagging options. It will no longer be useable as a search tag.
    </fuse-alert>
    -->

    <!-- Labels form -->
    <form
        class="mt-3"
        [formGroup]="labelsForm">

        <!-- New label -->
        <div
            class="flex items-center justify-start w-full max-w-100 mt-8"
            [formGroupName]="'newLabel'">
            <mat-form-field class="w-full">
                <mat-label>New Label</mat-label>
                <input
                    matInput
                    [formControlName]="'name'"
                    [placeholder]="'Label title'">
                <mat-select
                    [formControlName]="'color'"
                    [disableOptionCentering]="true"
                    matPrefix>
                    <mat-select-trigger class="h-6">
                        <mat-icon
                            [ngClass]="labelColorDefs[labelsForm.get('newLabel.color').value].text"
                            [svgIcon]="'heroicons_outline:tag'"></mat-icon>
                    </mat-select-trigger>
                    <div class="px-4 pt-5 text-xl font-semibold">Label color</div>
                    <div class="flex flex-wrap w-48 my-4 mx-3 -mr-5">
                        <ng-container *ngFor="let color of labelColors">
                            <mat-option
                                class="relative flex w-12 h-12 p-0 cursor-pointer rounded-full bg-transparent"
                                [value]="color"
                                #matOption="matOption">
                                <mat-icon
                                    class="absolute m-3 text-white"
                                    *ngIf="matOption.selected"
                                    [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                <span
                                    class="flex w-10 h-10 m-1 rounded-full"
                                    [ngClass]="labelColorDefs[color].bg"></span>
                            </mat-option>
                        </ng-container>
                    </div>
                </mat-select>
                <button
                    mat-icon-button
                    matSuffix
                    [disabled]="!labelsForm.get('newLabel').valid || !labelsForm.get('newLabel').dirty"
                    (click)="addLabel()">
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:plus-circle'"></mat-icon>
                </button>
            </mat-form-field>
        </div>

        <!-- Labels -->
        <div
        cdkDropList

            class="flex flex-col w-full max-w-100 mt-8"
            [formArrayName]="'labels'"
            (cdkDropListDropped)="drop($event)"
            >
            <!-- Label -->
            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
            <ng-container *ngFor="let label of labelsForm.get('labels')['controls']; let i=index">
                <mat-form-field class="" cdkDrag [cdkDragData]="label.value.id">
                    <input
                        matInput
                        [formControl]="label.get('name')"
                        (focus)="focusedLableIndex = i"
                        (keydown.enter)="updateLabelText(label.value)"
                        (blur)="onBlur($event, label.value, i)"
                        >
                    <mat-select
                        [formControl]="label.get('color')"
                        [disableOptionCentering]="true" 
                        (ngModelChange)="updateLabel(label.value)"
                        matPrefix>
                        <mat-select-trigger class="h-6">
                            <mat-icon
                                [ngClass]="labelColorDefs[label.get('color').value].text"
                                [svgIcon]="'heroicons_outline:tag'"></mat-icon>
                        </mat-select-trigger>
                        <div class="px-4 pt-5 text-xl font-semibold">Label color</div>
                        <div class="flex flex-wrap w-48 my-4 mx-3 -mr-5">
                            <ng-container *ngFor="let color of labelColors">
                                <mat-option
                                    class="relative flex w-12 h-12 p-0 cursor-pointer rounded-full bg-transparent"
                                    [value]="color"
                                    #matOption="matOption">
                                    <mat-icon
                                        class="absolute m-3 text-white"
                                        *ngIf="matOption.selected"
                                        [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                    <span
                                        class="flex w-10 h-10 m-1 rounded-full"
                                        [ngClass]="labelColorDefs[color].bg"></span>
                                </mat-option>
                            </ng-container>
                        </div>
                    </mat-select>
                
                    <button
                        mat-icon-button
                        matSuffix
                        matTooltip="Delete"
                        (click)="deleteLabel(label.get('id').value , i)">
                        <mat-icon
                            class="icon-size-5"
                            [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                    </button>
                  
                </mat-form-field>
                
            </ng-container>
        </div>
    </form>
</div>
